import { useTranslation } from "react-i18next";
import { Badge, type IBadgeProps } from "@components/Badge/Badge";

interface IAppKYCStatusPageProps {
  title: string;
  description: string;
  badgeProps: IBadgeProps;
}

export const AppKYCStatusPage: React.FC<IAppKYCStatusPageProps> = (props) => {
  const { title, description, badgeProps } = props;
  const { t } = useTranslation();

  return (
    <div className="flex flex-col p-4">
      <Badge
        className="mb-4"
        variant="rounded"
        icon={badgeProps.icon}
        size="medium"
        color={badgeProps.color ?? "green"}
      />
      <p className="text-gray-900 p-0 text-lg font-semibold">{t(title)}</p>
      <p className="text-sm text-grey-dark">{t(description)}</p>
    </div>
  );
};
